import { usePromotion } from '@barkinglabs/promotions-react';
import { PromotionConfigurationKind } from '@barkinglabs/promotions-types';
import { useLocale } from '../contexts/LocaleContext';
import { webApiUrl } from '../lib/fi-api/apiUtils';
import { resolvePromotionCouponCode } from '../lib/resolvePromotionCouponCode';

export interface ActivePromotion {
  /** Locale-resolved coupon code of the active SIMPLE promotion, if any. */
  couponCode?: string;
  /** Effective end of the promotion (extension included). */
  end?: Date;
  /** The promotion's own end, where its extension begins; absent when it has no extension. */
  extendedFrom?: Date;
}

/**
 * The currently active simple promotion for the shopper's country: its coupon code and end
 * date. Both are `undefined` when no promotion is active or the active variant is not the
 * SIMPLE kind. Mirrors the resolution inside `useShopPromotionBannerDetails` so the code we
 * report matches the code displayed on the promo banner.
 */
export function useActivePromotion(): ActivePromotion {
  const { language, country } = useLocale();
  const { variant, details } = usePromotion({ overrideApiHost: webApiUrl, country });

  if (variant?.configuration.kind !== PromotionConfigurationKind.SIMPLE) {
    return {};
  }
  return {
    couponCode: resolvePromotionCouponCode(variant.configuration, language, country),
    end: details?.end,
    extendedFrom: details?.extendedFrom,
  };
}

export function useActivePromoCode(): string | undefined {
  return useActivePromotion().couponCode;
}
